/* eslint-disable promise/param-names */
import {
  LAWYER_SAVE,
  LAWYERS_REQUEST,
  LAWYER_GET_NEW_ID,
  LAWYER_REQUEST_BY_ID,
  LAWYERS_REPLACE,
  LAWYERS_SUCCESS,
  LAWYERS_UPLOAD_FILE
} from '@/store/actions/lawyers';

import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/functions';
import Vue from 'vue';

import {sleep} from '@/utils/utils.js';
import querystring from 'querystring-browser';

const storageBaseLink = process.env.VUE_APP_STORAGE_BASE_LINK;

const state = { 
  lawyers: [],
  status: '', 
  hasLoadedOnce: false,
};

const getters = {
  lawyers: state => state.lawyers ? state.lawyers : [],
  lawyersLoaded: state => { 
    return state.hasLoadedOnce
  }
};

const actions = {
  [LAWYERS_REQUEST]: ({commit, dispatch}) => {
    if (!state.hasLoadedOnce) {
      return new Promise((resolve, reject) => {
        commit(LAWYERS_REQUEST)
      
        firebase.firestore().collection('lawyers').orderBy('name')
          .onSnapshot(querySnapshot => {
            let lawyers = []

            querySnapshot.docChanges().forEach(change => {
              lawyers.push(change.doc.data())
            })

            if (state.hasLoadedOnce == false) {
              commit(LAWYERS_SUCCESS, lawyers)
            } else {
              commit(LAWYERS_REPLACE, lawyers)
            }

            resolve();
          })
      })
    }
  },

  [LAWYER_REQUEST_BY_ID]: ({commit, dispatch}, lawyerId) => {
    return new Promise(async (resolve, reject) => {
      if (!state.hasLoadedOnce) {
        while (state.status === 'loading') {
          await sleep(300)
        }

        let lawyer = state.lawyers.find(elem => elem.id == lawyerId)

        if (lawyer != undefined) {
          resolve(JSON.parse(JSON.stringify(lawyer)))
        } else {
          reject('not found')
        }
      } else {
        let lawyer = state.lawyers.find(elem => elem.id == lawyerId)

        if (lawyer != undefined) {
          resolve(JSON.parse(JSON.stringify(lawyer)))
        }

        reject('not found')
      }
    })
  },

  [LAWYER_SAVE]: ({commit, dispatch}, lawyer) => {
    lawyer.categoryIds = lawyer.categories.map(elem => elem.id)
    lawyer.default = String(lawyer.default);
    commit(LAWYERS_REQUEST);

    if (lawyer.default == "true") {
      firebase.firestore().collection('lawyers').where('id', '>', lawyer.id).get()
          .then(querySnapshot => {
            for (let x in querySnapshot.docs) {
              querySnapshot.docs[x].ref.update({
                default: "false"
              })
            }
          })

      firebase.firestore().collection('lawyers').where('id', '<', lawyer.id).get()
          .then(querySnapshot => {
            for (let x in querySnapshot.docs) {
              querySnapshot.docs[x].ref.update({
                default: "false"
              })
            }
          })
    }

    return new Promise((resolve, reject) => {
      firebase.firestore().collection("lawyers").doc(String(lawyer.id)).set(lawyer)
        .then(() => {
          commit(LAWYERS_SUCCESS)
          resolve();
        })
    })
  },

  [LAWYER_GET_NEW_ID]: ({commit, dispatch}) => {
    commit(LAWYERS_REQUEST)

    return new Promise( (resolve, reject) => {
      var getNewLawyerId = firebase.functions().httpsCallable('getNewLawyerId');
      getNewLawyerId().then(result => {
        commit(LAWYERS_SUCCESS)
        resolve(result.data)
      }).catch(err => {
        reject(err)
      })
    });
  },

  [LAWYERS_UPLOAD_FILE]: ({commit}, args) => {
    var storageRef = firebase.storage().ref()

    return new Promise( (resolve, reject) => {
      storageRef.child('lawyers/' + args.lawyerId + '/' + args.file.name).put(args.file)
        .then(snapshot => {
          commit(LAWYERS_SUCCESS)
          resolve({
            fullPath: snapshot.metadata.fullPath,
            name: snapshot.metadata.name,
            size: snapshot.metadata.size,
            contentType: snapshot.metadata.contentType,
            timeCreated: snapshot.metadata.timeCreated,
            url: storageBaseLink.replace('[URL]', querystring.escape(snapshot.metadata.fullPath))
          })
        })
        .catch(err =>{
          reject(err)
        })
    });
  },
}


const mutations = {
  [LAWYERS_REQUEST]: (state) => {
    state.status = 'loading';
  },

  [LAWYERS_SUCCESS]: (state, lawyers) => {
    state.status = 'success';

    if (lawyers != undefined) {
      state.lawyers = lawyers;
      state.hasLoadedOnce = true;
    }
  },

  [LAWYERS_REPLACE]: (state, lawyers) => {
    lawyers.forEach(lawyer => {
      let rowIndex = state.lawyers.findIndex(elem => elem.id == lawyer.id)
      if (rowIndex != -1) {
        Vue.set(state.lawyers, rowIndex, lawyer)
      } else {
        state.lawyers.push(lawyer)
      }
    })
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
